import React from "react";
import { view } from "@risingstack/react-easy-state";
import { alertState } from "./kinesis-webrtc";
import "./StudentAlertButton.css";

const StudentAlertButton = view(
  ({ studentId, alerts, onClick, isPopupOpen }) => {
    const unreadCount = alertState.unreadAlerts[studentId] || 0;
    const hasAlerts = unreadCount > 0;
    const isUploadPhase = window.appState?.uploadPhaseEndTime;

    return (
      <div
        className="alert-icon-overlay"
        onClick={onClick}
        title={isPopupOpen ? "Close Alerts" : "View Alerts"}
      >
        <svg
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="none"
          stroke="#1a73e8"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9" />
          <path d="M13.73 21a2 2 0 0 1-3.46 0" />
        </svg>
        {/* Show counter only if we have alerts and not in upload phase */}
        {hasAlerts && !isUploadPhase && (
          <div className="alert-badge">{unreadCount}</div>
        )}
      </div>
    );
  }
);

export default StudentAlertButton;
